import { css, Paper, styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const StyledSkipToMainContentPaper = styled(Paper)(
  ({ theme }) => css`
    left: 50%;
    position: fixed;
    text-align: center;
    top: ${theme.spacing('LARGE')};
    transform: translateX(-50%);
    opacity: 0;
    z-index: 0;

    &:focus,
    &:focus-within {
      opacity: 1;
      z-index: 9999;
    }
  `
);
